import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  CardContent,
  Grid,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import IndiaMap from "../../../core/india-map";
import PastEngineReplacementTrend from "../../../components/overview/trend-overview/engine-replacement-trend";
import {
  formatAllInfoResponse,
  formatIndiaMapData,
} from "../../../components/overview/helper";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { DUMMY_PART_DATA, DUMMY_STATE_DATA, INDIA_MAP_DATA } from "./helper";
import CustomPiChart from "../../../components/overview/pi-chart";
import { formtHMRData } from "../../../components/overview/other-info";
import OemModelWiseSummary from "./oem-model-wise-summary";
import FailureInvoiceMonth from "./failure-invoice-month";
import CustomBarChart from "../../../components/overview/bar-chart";
import CustomModal from "../../../core/modal";
import AppContext from "../../../utils/context";
import { toast } from "react-toastify";
import { financialYears } from "../../../components/financial-year-calendar/helper";
import { COST_ACCESS_EMAILS } from "../../../utils/constants";

const EngineReplacementTrend = () => {
  const [indiaMapData, setIndiaMapData] = useState({ ...INDIA_MAP_DATA });
  const [hmrData, setHmrData] = useState([]);
  const [engineReplacementData, setEngineReplacementData] = useState({});
  const [invoiceMonthData, setInvoiceMonthData] = useState({});
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [isCallApis, setIsCallApis] = useState(false);
  const [dateType, setDateType] = useState("invoiceDate");
  const { userDetails = {} } = useContext(AppContext);
  const [engineReplacementViewType, setEngineReplacementViewType] =
    useState("count");

  const {
    engineReplacementDashboardFilter = {},
    setEngineReplacementDashboardFilter,
  } = useContext(AppContext);

  const loadStateData = (params = {}, setSplitScreenData = null) => {
    const payload = {
      engineReplacement: true,
      ...engineReplacementDashboardFilter,
      ...params,
    };
    // for (let key in engineReplacementDashboardFilter) {
    //   if (
    //     typeof engineReplacementDashboardFilter[key] === "object" &&
    //     engineReplacementDashboardFilter[key]?.value
    //   ) {
    //     payload[key] = [engineReplacementDashboardFilter[key].value];
    //   } else {
    //     payload[key] = [engineReplacementDashboardFilter[key]];
    //   }
    // }
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.DASHBOARD_STATE_WISE_DATA}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          const { hmrBucketCounts, oemOrgAndEngineModalCounts, stateCounts } =
            res;
          const result = stateCounts
            ?.map((ele) => ({
              state: ele?._id,
              count: ele?.count,
            }))
            .filter((st) => st.state && st);
          if (setSplitScreenData) {
            setSplitScreenData((prevVal) =>
              formatIndiaMapData(result, prevVal)
            );
          } else {
            setIndiaMapData((prevVal) => formatIndiaMapData(result, prevVal));
          }
          //hrm data
          const hmrresult = hmrBucketCounts
            ?.map((ele) => ele?.bucket && ele)
            .filter((buc) => buc && buc);
          if (setSplitScreenData) {
            setSplitScreenData(formtHMRData(hmrresult));
          } else {
            setHmrData(formtHMRData(hmrresult));
          }
        } else {
          toast.error("Failed to load");
        }
      })
      .catch((err) => console.error(err));
  };

  const loadHmrData = (params = {}, setSplitScreenData = null) => {
    const payload = {
      engineReplacement: true,
      ...params,
    };
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.DASHBOARD_HMR_DATA}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          const result = res
            ?.map((ele) => ele?.bucket && ele)
            .filter((buc) => buc && buc);
          if (setSplitScreenData) {
            setSplitScreenData(formtHMRData(result));
          } else {
            setHmrData(formtHMRData(result));
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const loadInvoiceData = (params = {}) => {
    const payload = {
      ...params,
      ...engineReplacementDashboardFilter,
      dateType: dateType,
      engineReplacement: true,
    };
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.DASHBOARD_INVOICE_DATA}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          setInvoiceMonthData(res);
        } else {
          setInvoiceMonthData({});
        }
      })
      .catch((err) => console.error(err));
  };

  const loadEngineReplacement = (params = {}) => {
    const payload = {
      ...params,
      ...engineReplacementDashboardFilter,
    };
    if (engineReplacementViewType === "cost") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.DASHBOARD_ENGINE_REPLACEMENT_COST}`,
        payload
      )
        .then((res) => {
          if (!res.message) {
            setEngineReplacementData(res);
          }
        })
        .catch((err) => console.error(err));
    } else {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.DASHBOARD_ENGINE_REPLACEMENT}`,
        payload
      )
        .then((res) => {
          if (!res.message) {
            setEngineReplacementData(res);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const handleCardClick = (cardData) => {
    setSelectedCard(cardData);
  };
  const closeModal = () => {
    setSelectedCard(null);
  };
  const renderModalContent = () => {
    switch (selectedCard) {
      case "stateWise":
        return (
          <IndiaMap
            data={indiaMapData}
            title=" State wise overview -Engine Replacement"
            downloadingData={indiaMapData || []}
            isModalOpen={true}
            loadStateData={loadStateData}
          />
        );
      case "hmrWise":
        return (
          <CustomPiChart
            title="HMR counts overview"
            data={hmrData}
            xDataKey="bucket"
            bDataKey="count"
            isModalOpen={true}
            loadHmrData={loadHmrData}
          />
        );

      case "invoiceMonth":
        return (
          <FailureInvoiceMonth
            inputData={invoiceMonthData}
            onDateTypeChange={(newDateType) => {
              setDateType(newDateType);
            }}
          />
        );
      case "engineReplacement":
        return (
          <PastEngineReplacementTrend
            data={engineReplacementData}
            viewType={engineReplacementViewType}
            setViewType={setEngineReplacementViewType}
          />
        );

      default:
        setSelectedCard(null);
        break;
    }
  };

  // Effect to load filters from sessionStorage when component mounts
  useEffect(() => {
    const storedFilters = JSON.parse(
      sessionStorage.getItem("engineReplacementFilters")
    );

    // If filters exist in sessionStorage, load them
    if (
      storedFilters &&
      storedFilters.length > 0 &&
      storedFilters?.length ===
        Object.keys(engineReplacementDashboardFilter)?.length
    ) {
      setSelectedFilters(storedFilters);
      setIsCallApis(true);
    } else {
      // If no filters in sessionStorage, set default filter
      sessionStorage.setItem("engineReplacementFilters", JSON.stringify([]));
      const financialYear = financialYears?.[0];
      const defaultFilters = [
        {
          type: "status",
          value: { label: "Open", value: "OPENED" },
        },
        {
          type: "financialYear",
          value: {
            label: financialYear?.label,
            value: financialYear?.label,
          },
        },
      ];
      setSelectedFilters(defaultFilters);
      setEngineReplacementDashboardFilter({
        status: ["OPENED"],
        financialYear: [financialYear?.label],
      });
      setIsCallApis(true);
    }
  }, []); // Run only on component mount

  // Save selected filters to sessionStorage whenever they change
  useEffect(() => {
    if (selectedFilters?.length > 0) {
      sessionStorage.setItem(
        "engineReplacementFilters",
        JSON.stringify(selectedFilters)
      );
    }
    return () => {
      if (Object.keys(engineReplacementDashboardFilter)?.length <= 0) {
        sessionStorage.setItem("engineReplacementFilters", JSON.stringify([]));
      }
    };
  }, [selectedFilters]);

  // Effect to update filters when state filter is changed
  useEffect(() => {
    if (engineReplacementDashboardFilter?.state) {
      setSelectedFilters((prevVal) => {
        const existingFilterIndex = prevVal.findIndex(
          (filter) => filter.type === "state"
        );
        if (existingFilterIndex !== -1) {
          const updatedFilters = [...prevVal];
          updatedFilters[existingFilterIndex] = {
            type: "state",
            value: engineReplacementDashboardFilter?.state?.[0],
          };
          return updatedFilters;
        } else {
          return [
            ...prevVal,
            {
              type: "state",
              value: engineReplacementDashboardFilter?.state?.[0],
            },
          ];
        }
      });
    } else {
      setSelectedFilters((prevVal) =>
        prevVal?.filter((filter) => filter.type !== "state")
      );
    }
  }, [engineReplacementDashboardFilter]);
  useEffect(() => {
    if (isCallApis) {
      loadStateData();
      loadEngineReplacement();
      loadInvoiceData();
    }
  }, [engineReplacementDashboardFilter, isCallApis, dateType]);
  useEffect(() => {
    if (isCallApis) {
      loadEngineReplacement();
    }
  }, [engineReplacementViewType]);

  return (
    <div className="page-body">
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Card>
            <CardContent>
              <IndiaMap
                data={indiaMapData}
                title=" State wise overview -Engine Replacement"
                downloadingData={indiaMapData || []}
                loadStateData={loadStateData}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Card
            sx={{ height: "90%", mb: 2 }}
            onClick={() => handleCardClick("hmrWise")}
          >
            <CardContent>
              <CustomPiChart
                title="HMR counts overview"
                data={hmrData}
                xDataKey="bucket"
                bDataKey="count"
                loadHmrData={loadHmrData}
              />
            </CardContent>
          </Card>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <FailureInvoiceMonth
                inputData={invoiceMonthData}
                onDateTypeChange={(newDateType) => {
                  setDateType(newDateType);
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item md={12} sx={{ mt: 2 }} xs={12} className="si-hide-mobile">
          <Card>
            <CardContent>
              <PastEngineReplacementTrend
                data={engineReplacementData}
                loadEngineReplacement={loadEngineReplacement}
                viewType={engineReplacementViewType}
                setViewType={setEngineReplacementViewType}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {selectedCard && (
        <CustomModal
          onClose={closeModal}
          contentClassName="custom-modal-dashboard-content"
          classesToPreventClosing={[
            "MuiPaper-elevation",
            "MuiTypography-root MuiTypography-h6 MuiTypography-gutterBottom",
            "MuiTypography-body2",
            "MuiAutocomplete-input MuiAutocomplete-inputFocused",
            "MuiAutocomplete-option Mui-focused",
            "MuiSvgIcon-root",
            "MuiInputBase-input MuiOutlinedInput-input",
            "ticket-filter-buttons",
            "MuiButtonBase-root MuiButton-root",
          ]}
        >
          {renderModalContent()}
        </CustomModal>
      )}
    </div>
  );
};

export default EngineReplacementTrend;
